import axios from "axios";
import { USER_LOGGED_IN, USER_LOGGED_OUT, END_URL, VALIDATION } from "./config";
import { API_URL } from "../../config/globals";
import Toast from "./../../config/toast";
import store from "./../../config/store";
import history from "../../config/history";

axios.defaults.baseURL = API_URL;
axios.interceptors.request.use(
  function (config) {
    const token = JSON.parse(localStorage.getItem("auth"))
      ? JSON.parse(localStorage.getItem("auth")).token
      : null;
    if (token) {
      config.headers["authorization"] = token;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (!error.response) {
            Toast(VALIDATION.SYSTEM_ERROR, "error");
            return Promise.reject(error);
        }

        if (error.response.status === 401 || error.response.data?.message === "Not authorized") {
            store.dispatch({ type: USER_LOGGED_OUT, payload: null });
            history.push("/");
        }

        return Promise.reject(error);
    }
);

export const login = (data) => {
  return (dispatch, getState) => {
    axios
      .post(END_URL.LOGIN, data)
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: USER_LOGGED_IN,
            payload: response.data,
          });
        }
      })
      .catch((err) => {
        const msg =
          err.response && err.response.data
            ? err.response.data.message
            : VALIDATION.SYSTEM_ERROR;
        Toast(msg, "error");
      });
  };
};

export const logout = () => {
  return (dispatch) => {
    dispatch({ type: USER_LOGGED_OUT });
  };
};
